var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"ps-page ps-page--single-post"},[(_vm.post)?[_c('article-detail-with-hero',{attrs:{"post":_vm.post}})]:_c('p',[_vm._v("not found.")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }